<template>
  <div>
    <l-button variant="secondary" @click="printDiv">
      Print
    </l-button>

    <div id="print-div" class="border p-3 mt-3 rounded">
      <slot/>
    </div>
  </div>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"

defineProps({
  id: String,
})

const printDiv = () => {
  // Get the element with the specified ID
  const printableDiv = document.getElementById("print-div")

  if (printableDiv) {
    // Create a new window and write the content to be printed
    const newWindow = window.open()
    newWindow.document.write("<html><head><title>Print</title></head><body>")
    newWindow.document.write(printableDiv.innerHTML)
    newWindow.document.write("</body></html>")
    newWindow.document.close()

    // Trigger the print dialog for the new window
    newWindow.print()
  } else {
    console.error('Element with ID "printableDiv" not found.')
  }
}
</script>
